/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  MetaCategorySuggestionControllerEnqueueMutationRequest,
  MetaCategorySuggestionControllerEnqueueMutationResponse,
  MetaCategorySuggestionControllerEnqueuePathParams,
  MetaCategorySuggestionControllerEnqueue401,
} from '../../types/MetaCategorySuggestionControllerEnqueue.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { metaCategorySuggestionEnqueue } from '../../methods/metaCategorySuggestionEnqueue.ts';
import { useMutation } from '@tanstack/react-query';

export const metaCategorySuggestionEnqueueMutationKey = () =>
  [{ url: '/api/user/telegram/category/meta/:metaCategoryId/suggestions/queue' }] as const;

export type MetaCategorySuggestionEnqueueMutationKey = ReturnType<typeof metaCategorySuggestionEnqueueMutationKey>;

/**
 * {@link /api/user/telegram/category/meta/:metaCategoryId/suggestions/queue}
 */
export function useMetaCategorySuggestionEnqueue<TContext>(
  options: {
    mutation?: UseMutationOptions<
      MetaCategorySuggestionControllerEnqueueMutationResponse,
      ResponseErrorConfig<MetaCategorySuggestionControllerEnqueue401>,
      {
        metaCategoryId: MetaCategorySuggestionControllerEnqueuePathParams['metaCategoryId'];
        data: MetaCategorySuggestionControllerEnqueueMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<MetaCategorySuggestionControllerEnqueueMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? metaCategorySuggestionEnqueueMutationKey();

  return useMutation<
    MetaCategorySuggestionControllerEnqueueMutationResponse,
    ResponseErrorConfig<MetaCategorySuggestionControllerEnqueue401>,
    {
      metaCategoryId: MetaCategorySuggestionControllerEnqueuePathParams['metaCategoryId'];
      data: MetaCategorySuggestionControllerEnqueueMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ metaCategoryId, data }) => {
        return metaCategorySuggestionEnqueue(metaCategoryId, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
